export const capitalize = (s) => {
  return s.replace(/\b\w/g, (l) => l.toUpperCase());
};

export const round = (value, precision) => {
  return Math.round(value * 10 ** precision) / 10 ** precision;
};

export const mergeDateandTime = (dateString, timeString) =>
  `${dateObjectToInputString(dateString)}T${timeString}:00`;

export const degToCompass = (deg) => {
  var val = Math.floor(deg / 22.5 + 0.5);
  var arr = [
    "N",
    "NNE",
    "NE",
    "ENE",
    "E",
    "ESE",
    "SE",
    "SSE",
    "S",
    "SSW",
    "SW",
    "WSW",
    "W",
    "WNW",
    "NW",
    "NNW",
  ];
  return arr[val % 16];
};

export const camelizeKeys = (o) => {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach((k) => {
      n[toCamel(k)] = camelizeKeys(o[k]);
    });

    return n;
  } else if (Array.isArray(o)) {
    return o.map((i) => {
      return camelizeKeys(i);
    });
  }

  return o;
};

export const snakeKeys = (o) => {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach((k) => {
      n[toSnake(k)] = snakeKeys(o[k]);
    });

    return n;
  } else if (Array.isArray(o)) {
    return o.map((i) => {
      return snakeKeys(i);
    });
  }

  return o;
};

const toCamel = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1
      .toUpperCase()
      .replace("-", "")
      .replace("_", "");
  });
};

const toSnake = (str) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const isObject = (o) => {
  return o === Object(o) && !Array.isArray(o) && typeof o !== "function";
};

export const dateObjectToInputString = (date) =>
  date?.toISOString()?.split("T")[0];

export const getDateFromISO = (isoString) => {
  const date = isoString.split("T")[0];
  return date;
};
export const getTimeFromISO = (isoString) => {
  const time = isoString.split("T")[1];
  const noSeconds = time?.slice(0, 5);
  return noSeconds;
};
